import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import './css/customSideBar.css'
import '@fontsource/inter/400.css' // Regular
import '@fontsource/inter/600.css' // Semi-bold (optional)
import { PUBLIC_URL } from './config'

const container = document.getElementById('root')
const root = createRoot(container)
// Register service worker

// Ask for Notification permission if not already granted
// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((registration) => {
        console.log('Service Worker registered:', registration)
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error)
      })
  })
} else {
  console.warn('Service Worker not supported in this browser.')
}

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
